var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 16 16",
    id: "Magnifer--Streamline-Solar.svg",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Magnifer Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line Duotone/Search/Magnifer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#737373",
    d: "M7.158125 13.653500000000001C10.7454375 13.653500000000001 13.653500000000001 10.7454375 13.653500000000001 7.158125C13.653500000000001 3.570875 10.7454375 0.6628125 7.158125 0.6628125C3.570875 0.6628125 0.6628125 3.570875 0.6628125 7.158125C0.6628125 10.7454375 3.570875 13.653500000000001 7.158125 13.653500000000001Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M11.944187500000002 11.944187500000002L14.337187499999999 14.337187499999999",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearch);
export default __webpack_public_path__ + "static/media/newSearch.cc51239bb22393bd0a10d790f14881e0.svg";
export { ForwardRef as ReactComponent };